import React from "react";
import PageShell from "@/components/PageShell";

const SECTIONS = [
  {
    h: "1. Acceptance of terms",
    p: "By creating an account or using CloutRise, you agree to these Terms of Service. If you do not agree, please do not use the service.",
  },
  {
    h: "2. What CloutRise provides",
    p: "CloutRise is an AI-assisted social media growth platform offering content tools, scheduling, analytics and growth guidance for TikTok, Instagram, YouTube and Facebook. Projected growth figures are estimates for illustration and are not guarantees of a specific result.",
  },
  {
    h: "3. Your account",
    p: "You are responsible for the accuracy of the information you provide and for keeping your login secure. You must be at least 13 years old (or the minimum age required in your country) to use CloutRise.",
  },
  {
    h: "4. Acceptable use",
    p: "You agree not to misuse the service — including attempting to gain unauthorized access, violating any platform's terms, or using CloutRise for unlawful, misleading or abusive activity. Growth is organic; we do not provide bots, fake followers or password-based automation.",
  },
  {
    h: "5. Subscriptions and billing",
    p: "Paid plans are billed in advance on a monthly or yearly cycle through our payment processor, Stripe. Your plan renews automatically until you cancel. You can upgrade, downgrade or cancel anytime from the Billing page — changes to your plan are prorated automatically.",
  },
  {
    h: "6. Cancellations and refunds",
    p: "When you cancel, your plan remains active until the end of the current paid period, after which it will not renew. Every plan includes a 7-day money-back guarantee for new subscribers. For refund requests, contact support@clout-rise.com.",
  },
  {
    h: "7. AI-generated content",
    p: "Content produced by our AI tools is provided to assist you. You are responsible for reviewing and how you use it, and for ensuring it complies with the rules of the platforms you post to.",
  },
  {
    h: "8. Intellectual property",
    p: "CloutRise and its branding, software and design are owned by us. Content you create or upload remains yours; you grant us the limited permission needed to store and display it back to you within the service.",
  },
  {
    h: "9. Disclaimers and limitation of liability",
    p: "The service is provided 'as is' without warranties of any kind. To the maximum extent permitted by law, CloutRise is not liable for indirect or consequential damages, or for outcomes on third-party platforms outside our control.",
  },
  {
    h: "10. Changes and termination",
    p: "We may update these terms or the service over time. We may suspend or terminate accounts that violate these terms. If we make material changes, we'll update the date below.",
  },
  {
    h: "11. Contact",
    p: "Questions about these terms? Email growth@clout-rise.com and we'll help.",
  },
];

const Terms = () => (
  <PageShell
    testid="terms-page"
    kicker="Legal"
    title="Terms of Service"
    subtitle="The agreement between you and CloutRise when you use our platform."
  >
    <p className="text-sm text-muted-foreground mb-10">Last updated: June 2026</p>
    <div className="space-y-8">
      {SECTIONS.map((s) => (
        <div key={s.h}>
          <h2 className="font-heading text-xl font-bold mb-2">{s.h}</h2>
          <p className="text-muted-foreground leading-relaxed">{s.p}</p>
        </div>
      ))}
    </div>
  </PageShell>
);

export default Terms;
